import ChekItOut from "../Common/ChekItOut";
import AepsOnboard from "../Views/Main/BankingService/AEPSICICI/AEPSONBOARD/index";
import Aeps from "../Views/Main/BankingService/AEPSICICI/AEPS/Aeps";
import GetRemitter from "../Views/Main/DMT/GetRemitter";
import KycForm from "../Views/Main/DMT/KycForm";
import RemitterReg from "../Views/Main/DMT/RemitterReg";
import Dashboard from "../Views/Main/Dashboard";
import Busticket from "../Views/Main/OtherServices/Bus/Busticket";
import Flights from "../Views/Main/OtherServices/Flights/Flight";
import Hotel from "../Views/Main/OtherServices/Hotel/Hotel";
import Verification from "../Views/Main/Payout/Verification";
import Profile from "../Views/Main/Profile";
import RechargeAndBill from "../Views/Main/Recharge&Bill";
import Uti from "../Views/Main/UTI";
import ProtectedAuth from "./PrivateAuth";
import EkycIndex from "../Views/Main/BankingService/AEPSICICI/AepsEkyc/EkycIndex";
import WithdrawalMoney from "../Views/Main/BankingService/AEPSICICI/AEPS/WithdrawalMoney";
import Addmembers from "../Views/Main/Members/Addmembers";
import { AddBankAccount, AepsCashWithdrawl } from "../ApiServices/Apifun";
import Ministatement from "../Views/Main/BankingService/AEPSICICI/AEPS/Ministatement";
import AadharPay from "../Views/Main/BankingService/AEPSICICI/AEPS/AadharPay";
import BalanceEnquiry from "../Views/Main/BankingService/AEPSICICI/AEPS/BalanceEnquiry";
import FundRequest from "../Views/Main/FundRequest/FundRequest";
import { Images } from "../Controller";
import Default from "./404";
import NotAvailable from "./NotAvailable";
import CashWithdrawlReport from "../Views/Main/Reports/CashwithdrwalReport";
import MiniStatementReport from "../Views/Main/Reports/MinistatementReport";
import AadharPayReport from "../Views/Main/Reports/AadharPayRepoer";
import PayoutReport from "../Views/Main/Reports/PayoutReport";
import RechargeReport from "../Views/Main/Reports/RechargeReport";
import BbpsReport from "../Views/Main/Reports/BbpsReports";
import DmtReport from "../Views/Main/Reports/DmtReport";
import UtiReport from "../Views/Main/Reports/UtiReport";
import WalletReport from "../Views/Main/Reports/WalletReport";
import FundRequestReport from "../Views/Main/Reports/FundRequestReport";
import Upi from "../Views/Main/UPI/Upi";
import KycStatus from "../Views/Main/Dashboard/KycStatus";
import ComingSoon from "./ComingSoon";
import MemberLists from "../Views/Main/Members/MemberList";
import ExpressPayout from "../Views/Main/ExpressPAyout/ExpressPayout";
import XpressPayoutReport from "../Views/Main/Reports/XpressPayoutReport";
import BalanceEnquireyReport from "../Views/Main/Reports/BalanceEnquireyReport";
import PanServices from "../Views/Main/PanServices";
import NsdlReport from "../Views/Main/Reports/NsdlReport";
import UpiForm from "../Views/Main/UPIDMT/UpiForm";
import UpiDmtReport from "../Views/Main/Reports/UpidmtReport";
import AepsYesMainScreen from "../Views/Main/BankingService/AEPSYES/AEPS/Index";
import AepsYesOnboard from "../Views/Main/BankingService/AEPSYES/AEPSONBOARD";
import YesBankBioMetric from "../Views/Main/BankingService/AEPSYES/AepsEkyc/EkycIndex";
import YesBankAepsReport from "../Views/Main/Reports/YesBankAepsReport";
import GiveTopup from "../Views/Main/GiveTopUp/GiveTopup";
import MainTab from "../Views/Main/Recharge&Bill/MainTab";
import Memberkyc from "../Views/Main/BankingService/AEPSYES/MemberKyc/Memberkyc";
import MAtmReport from "../Views/Main/Reports/MAtmReport";
import Prepaid from "../Views/Main/Recharge&Bill/Prepaid";
import FlightBook from "../Views/Main/OtherServices/Flights/FlightBook";
import FlightReport from "../Views/Main/Reports/FlightReport";
import BookingDetail from "../Views/Main/OtherServices/Flights/BookingDetail";
import BusBook from "../Views/Main/OtherServices/Bus/BusBook";
import BusBookingDetail from "../Views/Main/OtherServices/Bus/BusBookingDetail";
import BusReport from "../Views/Main/Reports/BusReport";
import HotelBookPage from "../Views/Main/OtherServices/Hotel/HotelBook";
import HotelReport from "../Views/Main/Reports/HotelReport";
// import Invoice from "../Views/Main/Invoice/Invoice";
import AepsCredo from "../Views/Main/BankingService/AepsCredo/AepsCredo";
import CredoAepsTransaction from "../Views/Main/Reports/CredoAepsTransaction";
import AddFundReport from "../Views/Main/Reports/AddFundReport";
import AddFund from "../Views/Main/AddFund/AddFund";
import AddYourBankAccount from "../Views/Main/AddBankAccount/AddYourBankAccount";
import AddedBankReport from "../Views/Main/Reports/AddedBankReport";
// import CashDeposit from "../Views/Main/BankingService/AEPSICICI/AEPS/CashDeposit";
// import CashDepositReport from "../Views/Main/Reports/CashDepositReport";
import CashDeposit from "../Views/Main/BankingService/AEPSICICI/AEPS/CashDeposit";
import CashDepositReport from "../Views/Main/Reports/CashDepositReport";
import PrivacyPolicy from "../Views/Main/About/privacyPolicy";
import Termsandcondition from "../Views/Main/About/terms&condition";
import ChekItOutV1 from "../Common/ChekItOutV1";
import RechargeAndBillV1 from "../Views/Main/Recharge&BillV1";
import AllInOne from "../Views/Main/BankingService/AEPSICICI/AEPS/AllInOne";
import AEPS3Component from "../Views/Main/AEPS-3";
import Aeps3MerchantOnboard from "../Views/Main/AEPS-3/Aeps3MerchantOnboard";
import PayoutAeps3Report from "../Views/Main/Reports/PayoutAeps3Report";
import AepsWalletReport from "../Views/Main/Reports/AepsWalletReport";
import Aeps4Reports from "../Views/Main/Reports/Aeps4Reports";
import VerificationAeps3 from "../Views/Main/Aeps-3 Payout/VerificationAeps3";

export const PrivateAuth = () => {
  return [
    {
      element: <ProtectedAuth />,
      children: [
        {
          path: "/Dashboard",
          element: <Dashboard />,
        },
        {
          path: "/kycStatus",
          element: <KycStatus />,
        },
        {
          path: "/fundRequest",
          element: <FundRequest />,
        },

        // RECHARGE ROUTES STARTED
        {
          path: "/recharge",
          element: <Prepaid />,
        },
        {
          path: "/bbps",
          element: <RechargeAndBill />,
        },
        {
          path: "/addFund",
          element: <AddFund />,
        },
        {
          path: "/checkOut",
          element: <ChekItOut />,
        },
        // RECHARGE ROUTES ENDED
        // {
        //   path: "/transactionStatus",
        //   element: <TransactionSuccess />,
        // },

        //AEPS ROUTES STARTED
        // {
        //   path: "/banking/aeps-yesbank",
        //   element: <AepsYesMainScreen />,
        // },
        {
          path: "/banking/aeps2-2fa",
          element: <AepsCredo />,
        },
        {
          path: "/banking/waiting",
          element: <AepsCredo />,
        },
        {
          path: "/bbps/v1",
          element: <RechargeAndBillV1 />,
        },
        {
          path: "/banking/aeps2-onboard",
          element: <AepsCredo />,
        },
        {
          path: "/checkOutV1",
          element: <ChekItOutV1 />,
        },
        {
          path: "/banking/aeps-yesbank",
          element: <AepsYesMainScreen />,
        },
        {
          path: "/banking/aeps-onboard",
          element: <AepsOnboard />,
        },
        {
          path: "/privacypolicy",
          element: <PrivacyPolicy />,
        },
        {
          path: "/terms&condition",
          element: <Termsandcondition />,
        },
        // {
        //   path: "/banking/aepsyes-memberkyc",
        //   element: <Memberkyc />,
        // },
        // {
        //   path: "/banking/aepsyes-onboard",
        //   element: <AepsYesOnboard />,
        // },
        {
          path: "/banking/aeps",
          element: <Aeps />,
        },
        {
          path: "/banking/aeps/all",
          element: <AllInOne />,
        },
        {
          path: "/banking/aeps-ekyc",
          element: <EkycIndex />,
        },
        // {
        //   path: "/banking/aepsyes-ekyc",
        //   element: <YesBankBioMetric />,
        // },
        {
          path: "/banking/aeps-cash-withdrawl",
          element: <WithdrawalMoney />,
        },
        {
          path: "/banking/aeps-cash-deposit",
          element: <CashDeposit />,
        },
        {
          path: "/banking/aeps-aadharpay",
          element: <AadharPay />,
        },
        {
          path: "/banking/aeps-balanceEnquiry",
          element: <BalanceEnquiry />,
        },
        {
          path: "/banking/aeps-miniStatement",
          element: <Ministatement />,
        },
        //AEPS ROUTES ENDED
        // {
        //   path: "/upi",
        //   element: <Upi />,
        // },
        {
          path: "/upi-dmt",
          element: <UpiForm />,
        },
        //aeps-3 PAyout Route
        {
          path: "/aeps3/payout/verification",
          element: <VerificationAeps3 />,
        },
        {
          path: "/banking/aeps3-merchant-onboard",
          element: <Aeps3MerchantOnboard />,
        },
        {
          path: "/aeps-3",
          element: <AEPS3Component />,
        },
        //REPORTS ROUTES STARTED
        {
          path: "/Report/aeps_wallet_report",
          element: <AepsWalletReport />,
        },
        {
          path: "/aeps3/payout/report",
          element: <PayoutAeps3Report />,
        },
        {
          path: "/Report/aeps-3",
          element: <Aeps4Reports />,
        },
        {
          path: "/Report/cash-transaction",
          element: <CredoAepsTransaction />,
        },
        // {
        //   path: "/Report/cash-deposit",
        //   element: <CashDepositReport />,
        // },
        {
          path: "/Report/cash-deposit",
          element: <CashDepositReport />,
        },
        {
          path: "/Report/cash-withdrawl",
          element: <CashWithdrawlReport />,
        },
        {
          path: "/Report/balance-enquirey",
          element: <BalanceEnquireyReport />,
        },
        {
          path: "/Report/mini-statement",
          element: <MiniStatementReport />,
        },
        {
          path: "/Report/aadharpay",
          element: <AadharPayReport />,
        },
        {
          path: "/Report/payout",
          element: <PayoutReport />,
        },
        {
          path: "/Report/addfundreport",
          element: <AddFundReport />,
        },
        {
          path: "/Report/recharge",
          element: <RechargeReport />,
        },
        {
          path: "/Report/bbps",
          element: <BbpsReport />,
        },
        {
          path: "/Report/dmt",
          element: <DmtReport />,
        },
        {
          path: "/Report/uti",
          element: <UtiReport />,
        },
        {
          path: "/Report/wallet",
          element: <WalletReport />,
        },
        {
          path: "/Report/wallet",
          element: <WalletReport />,
        },
        {
          path: "/Report/nsdl",
          element: <NsdlReport />,
        },
        {
          path: "/Report/fund-request",
          element: <FundRequestReport />,
        },
        {
          path: "/Report/xpressPayout",
          element: <XpressPayoutReport />,
        },
        {
          path: "/Report/m-atm",
          element: <MAtmReport />,
        },
        // {
        //   path: "/Report/yesBank",
        //   element: <YesBankAepsReport />,

        // },
        {
          path: "/Report/upi-dmt",
          element: <UpiDmtReport />,
        },
        {
          path: "/Report/flight",
          element: <FlightReport />,
        },
        {
          path: "/Report/bus",
          element: <BusReport />,
        },
        {
          path: "/Report/hotel",
          element: <HotelReport />,
        },
        // REPORTS ROUTES ENDED

        //DMT ROUTES STARTED
        {
          path: "/dmt/submitKyc",
          element: <KycForm />,
        },
        {
          path: "/dmt/remitters",
          element: <GetRemitter />,
        },
        {
          path: "/dmt/addRemitters",
          element: <RemitterReg />,
        },
        //DMT ROUTES ENDED

        //PAYOUT ROUTE
        {
          path: "/payout/verification",
          element: <Verification />,
        },
        //express payout ROUTE
        {
          path: "/express-payout",
          element: <ExpressPayout />,
        },

        // UTI ROUTE
        {
          path: "/uti",
          element: <Uti />,
        },
        {
          path: "/panServices",
          element: <PanServices />,
        },

        // {
        //   path: "/history/:id",
        //   element: <Invoice />,
        // },

        // TRAVEL ROUTES STARTED
        {
          path: "/flights",
          element: <Flights />,
        },
        {
          path: "/booking-details",
          element: <BookingDetail />,
        },
        {
          path: "/flight-book",
          element: <FlightBook />,
        },
        {
          path: "/bus/:origin?/:destination?/:departure?/:arrival?",
          element: <Busticket />,
        },
        {
          path: "/bus-book",
          element: <BusBook />,
        },
        {
          path: "/bus-bookingDetail",
          element: <BusBookingDetail />,
        },
        {
          path: "/hotel",
          element: <Hotel />,
        },
        {
          path: "/hotel-book",
          element: <HotelBookPage />,
        },
        // TRAVEL ROUTES ENDED

        {
          path: "/personal-info",
          element: <Profile />,
        },
        {
          path: "/add-member",
          element: <Addmembers />,
        },
        {
          path: "/memberList",
          element: <MemberLists />,
        },

        // ERROR ROUTES
        {
          path: "/not-available",
          element: <NotAvailable />,
        },
        {
          path: "/coming-soon",
          element: <ComingSoon />,
        },
        {
          path: "*",
          element: <Default />,
        },
        {
          path: "/give-topup",
          element: <GiveTopup />,
        },
        {
          path: "/addbankaccount",
          element: <AddYourBankAccount />,
        },
        {
          path: "/Report/addbankreport",
          element: <AddedBankReport />,
        },
        // ERROR ROUTES ENDED
      ],
    },
  ];
};
